export const GENERIC_ERROR =
  "Óvænt villa kom upp, vinsamlegast hafið samband við kerfisstjóra";
export const REQUIRED = "Nauðsynlegt";
